export default "__VITE_ASSET__BwRgzwha__"